import $ from 'jquery';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';

/**
 * The default UI renders `title` as the slide caption, but the property is not
 * part of the core Item type.
 */
type GalleryItem = PhotoSwipe.Item & { title?: string };

/**
 * Main initialization, called after DOMContentLoaded.
 */
function init() {
  const openGallery = (items: GalleryItem[], index = 0) => {
    const options: PhotoSwipeUIDefault.Options = {
      index,
      history: false,
      focus: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      shareEl: false,
      bgOpacity: 0.95,
    };

    const template =
      '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"><div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"><div class="pswp__top-bar"><div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button><button class="pswp__button pswp__button--share" title="Share"></button><button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button><button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button><div class="pswp__preloader"><div class="pswp__preloader__icn"><div class="pswp__preloader__cut"><div class="pswp__preloader__donut"></div></div></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"><div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button><button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button><div class="pswp__caption"><div class="pswp__caption__center"></div></div></div></div></div>';

    if (document.querySelectorAll('.pswp').length < 1) {
      $('body').append(template);
    }

    const pswpElement = document.querySelectorAll<HTMLElement>('.pswp')[0];
    const gallery = new PhotoSwipe<PhotoSwipeUIDefault.Options>(
      pswpElement,
      PhotoSwipeUIDefault,
      items,
      options,
    );
    gallery.init();
  };

  $('.news-img-wrap').each(function initGallery() {
    const $pic = $(this);

    const getItems = () => {
      const items: GalleryItem[] = [];
      $pic.find('a[data-size]').each(function collectItem() {
        const $link = $(this);
        const [width, height] = String($link.data('size')).split('x');
        const title = $link.attr('title');
        const description = $link
          .parents('.outer')
          .find('.news-img-caption')
          .text();

        let itemDescription = '';
        if (title) itemDescription += `<h3>${title}</h3>`;
        if (description) itemDescription += `<p>${description}</p>`;

        items.push({
          src: $link.attr('href'),
          w: Number(width),
          h: Number(height),
          title: itemDescription,
        });
      });
      return items;
    };

    const items = getItems();

    $pic.on('click', 'a[data-size]', function openOnClick(event) {
      event.preventDefault();
      event.stopPropagation();

      openGallery(items, $(this).parents('.outer').index());
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
